/* NEXSORA StarGlow / SunsetGlow page behaviour. No dependencies. */
(function () {
  'use strict';
  if (window.__sgLoaded) return;
  window.__sgLoaded = true;

  var root = document.documentElement;
  var mqR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = function () { return mqR.matches; };
  var canHover = function () { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; };
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clean = function (v) { return String(v == null ? '' : v).replace(/<[^>]*>/g, '').trim(); };
  var urlKey = function (u) { return String(u || '').split('?')[0]; };

  /* ---------- Scroll-linked variables (written only where they are used) ---------- */
  var active = [], ticking = false, docMax = 1, bg = null, lastSy = -1;
  function measure() { docMax = Math.max(1, root.scrollHeight - window.innerHeight); }
  function frame() {
    ticking = false;
    var sy = window.pageYOffset || 0, vh = window.innerHeight;
    if (bg && Math.abs(sy - lastSy) >= 1) {
      lastSy = sy;
      bg.style.setProperty('--sg-sy', sy.toFixed(0));
      bg.style.setProperty('--sg-p', Math.min(1, sy / docMax).toFixed(3));
    }
    for (var i = 0; i < active.length; i++) {
      var s = active[i], r = s.getBoundingClientRect(), p;
      if (s.classList.contains('sg-hero')) p = -r.top / Math.max(1, r.height);
      else p = (vh - r.top) / (vh + r.height);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      if (!s.__lp || Math.abs(p - s.__lp) > 0.002) { s.__lp = p; s.style.setProperty('--sp', p.toFixed(3)); }
    }
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function initScroll() {
    if (reduced()) return;
    bg = qs('.sg-bg, .ss-bg');
    measure();
    window.addEventListener('resize', function () { measure(); req(); }, { passive: true });
    window.addEventListener('load', function () { measure(); req(); });
    window.addEventListener('scroll', req, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = active.indexOf(en.target);
          if (en.isIntersecting && i < 0) active.push(en.target);
          if (!en.isIntersecting && i > -1) active.splice(i, 1);
        });
        req();
      }, { rootMargin: '10% 0px 10% 0px' });
      var uses = '.sg-hero__img,.sg-show__img,.sg-cta__img,.sg-show__orbit,.sg-cta__orbit,.ss-stage__ring,.ss-sun';
      qsa('[data-sg-sec]').forEach(function (s) { if (s.classList.contains('sg-hero') || qs(uses, s)) io.observe(s); });
    }
    req();
  }

  /* ---------- Reveal that replays each time it enters view ---------- */
  function initReveal(scope) {
    var els = qsa('.sg-rv', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) en.target.classList.add('is-in');
        else if (!reduced()) en.target.classList.remove('is-in');
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { if (!e.__sgrv) { e.__sgrv = 1; io.observe(e); } });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sg-scroll]');
    if (!a) return;
    var t = qs(a.getAttribute('data-sg-scroll'));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
  });

  function initTilt(scope) {
    if (!canHover() || reduced()) return;
    qsa('.sg-tilt', scope).forEach(function (box) {
      if (box.__sgt) return; box.__sgt = 1;
      var fr = qs('.sg-show__frame', box), raf = 0, rx = 0, ry = 0;
      if (!fr) return;
      function paint() { raf = 0; fr.style.setProperty('--rx', rx.toFixed(2) + 'deg'); fr.style.setProperty('--ry', ry.toFixed(2) + 'deg'); }
      box.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = box.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 8;
        rx = -((e.clientY - r.top) / r.height - 0.5) * 8;
        if (!raf) raf = requestAnimationFrame(paint);
      });
      box.addEventListener('pointerleave', function () { rx = 0; ry = 0; if (!raf) raf = requestAnimationFrame(paint); });
    });
  }

  function initCompare(scope) {
    qsa('.sg-cmp', scope).forEach(function (box) {
      var rng = qs('.sg-cmp__range', box);
      if (!rng || box.__sgc) return; box.__sgc = 1;
      function set() { box.style.setProperty('--pos', rng.value + '%'); }
      rng.addEventListener('input', set); set();
    });
  }

  function initScenes(scope) {
    qsa('[data-sg-scenes]', scope).forEach(function (box) {
      if (box.__sgs) return; box.__sgs = 1;
      var scenes = qsa('.sg-scene', box), tabs = qsa('.sg-tab', box), cur = 0, timer = 0, visible = false;
      function show(i) {
        cur = (i + scenes.length) % scenes.length;
        scenes.forEach(function (s, n) { s.classList.toggle('is-on', n === cur); });
        tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === cur ? 'true' : 'false'); });
      }
      function stop() { clearInterval(timer); timer = 0; }
      function start() { if (reduced() || timer || !visible) return; timer = setInterval(function () { show(cur + 1); }, 6000); }
      tabs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); stop(); }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); else stop(); }).observe(box);
      }
      show(0);
    });
  }

  /* ---------- Purchase area ---------- */
  function setCartCount(n) {
    var link = qs('.nx-header__cart');
    if (!link) return;
    var b = qs('.nx-header__cart-count', link);
    if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'nx-header__cart-count'; link.appendChild(b); } b.textContent = n; }
    else if (b) b.remove();
  }

  /* Swipeable gallery: native scroll-snap (swipe on touch, arrows on desktop) + auto-advance every 5s */
  function buildGallery(box, thumbs, startKey) {
    var holder = qs('.sg-gal__main', box);
    if (!holder || thumbs.length < 1) return null;
    var firstImg = qs('img', holder), alt = (firstImg && firstImg.alt) || '';
    var track = document.createElement('div');
    track.className = 'sg-gal__track';
    track.setAttribute('role', 'group');
    track.setAttribute('aria-roledescription', 'carousel');
    track.setAttribute('aria-label', 'Product images');
    var dots = document.createElement('div'); dots.className = 'sg-gal__dots'; dots.setAttribute('aria-hidden', 'true');
    thumbs.forEach(function (t, n) {
      var s = document.createElement('div'); s.className = 'sg-gal__slide';
      var im = document.createElement('img');
      im.src = t.dataset.src; im.alt = alt; im.width = 1000; im.height = 1000; im.decoding = 'async';
      if (n > 1) im.loading = 'lazy';
      s.appendChild(im); track.appendChild(s);
      dots.appendChild(document.createElement('i'));
    });
    holder.innerHTML = '';
    holder.appendChild(track);
    holder.appendChild(dots);
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'sg-gal__nav sg-gal__nav--prev'; next.className = 'sg-gal__nav sg-gal__nav--next';
    prev.setAttribute('aria-label', 'Previous image'); next.setAttribute('aria-label', 'Next image');
    prev.innerHTML = next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
    holder.appendChild(prev); holder.appendChild(next);

    var n = thumbs.length, cur = 0, timer = 0, visible = false, stopped = false, raf = 0;
    function setActive(i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      var t = thumbs[i], strip = t && t.parentNode;
      if (strip && strip.scrollTo) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
    }
    function goTo(i, smooth) {
      i = ((i % n) + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduced() ? 'smooth' : 'auto' });
      setActive(i);
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w);
        if (i !== cur && i >= 0 && i < n) setActive(i);
      });
    }, { passive: true });

    function stop(forever) { clearInterval(timer); timer = 0; if (forever) stopped = true; }
    function start() {
      if (reduced() || stopped || timer || n < 2 || !visible) return;
      timer = setInterval(function () { if (!document.hidden && visible) goTo(cur + 1, true); }, 5000);
    }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { stop(true); }, { passive: true }); });
    prev.addEventListener('click', function () { stop(true); goTo(cur - 1, true); });
    next.addEventListener('click', function () { stop(true); goTo(cur + 1, true); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { stop(true); goTo(k, true); }); });
    holder.addEventListener('mouseenter', function () { stop(false); });
    holder.addEventListener('mouseleave', function () { start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); else stop(false); }).observe(holder);
    }
    var startIdx = 0;
    thumbs.forEach(function (t, k) { if (urlKey(t.dataset.src) === startKey) startIdx = k; });
    goTo(startIdx, false);
    return { goTo: goTo, stop: stop, indexOf: function (u) { var r = -1; thumbs.forEach(function (t, k) { if (urlKey(t.dataset.src) === urlKey(u)) r = k; }); return r; } };
  }

  function initBuy(box) {
    if (box.__sgb) return; box.__sgb = 1;
    var form = qs('[data-sg-form]', box), idIn = qs('[name="id"]', form);
    var pills = qsa('[data-sg-var]', box), thumbs = qsa('.sg-thumb', box);
    var mainImg = qs('[data-sg-main]', box) || qs('.sg-gal__main img', box);
    var qty = qs('[data-sg-qty]', box), msg = qs('[data-sg-msg]', box);
    var addBtns = qsa('[data-sg-add]', document), buyBtn = qs('[data-sg-buynow]', box);
    var gallery = buildGallery(box, thumbs, mainImg ? urlKey(mainImg.getAttribute('src')) : '');
    function text(sel, v) { qsa(sel, document).forEach(function (el) { el.textContent = clean(v); }); }
    function select(p, push) {
      pills.forEach(function (x) { var on = x === p; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      idIn.value = p.dataset.id;
      text('[data-sg-price]', p.dataset.price);
      text('[data-sg-name]', p.dataset.name);
      qsa('[data-sg-compare]', document).forEach(function (el) { var c = clean(p.dataset.compare); el.textContent = c; el.hidden = !c; });
      qsa('[data-sg-save]', document).forEach(function (el) { var c = clean(p.dataset.save); el.textContent = c; el.hidden = !c; });
      var ok = p.dataset.avail === 'true';
      addBtns.forEach(function (b) { b.disabled = !ok; b.textContent = ok ? b.getAttribute('data-label') : 'Sold out'; });
      if (buyBtn) buyBtn.disabled = !ok;
      if (push && gallery && p.dataset.img) { var k = gallery.indexOf(p.dataset.img); if (k > -1) { gallery.stop(true); gallery.goTo(k, true); } }
      if (push && window.history && history.replaceState) { try { history.replaceState(null, '', '?variant=' + p.dataset.id); } catch (e) {} }
    }
    pills.forEach(function (p) { p.addEventListener('click', function () { if (!p.disabled) select(p, true); }); });
    qsa('[data-sg-step]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1; v += parseInt(b.getAttribute('data-sg-step'), 10);
        qty.value = Math.min(20, Math.max(1, v));
      });
    });
    function add(thenCheckout, btn) {
      var q = Math.min(20, Math.max(1, parseInt(qty.value, 10) || 1));
      var label = btn.getAttribute('data-label') || btn.textContent;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = thenCheckout ? '…' : 'Adding…';
      if (msg) msg.textContent = '';
      function restore() { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = thenCheckout ? 'Buy it now' : label; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idIn.value), quantity: q }] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description ? j.description : 'error'); }); return r.json(); })
        .then(function () {
          if (thenCheckout) { window.location.href = '/checkout'; return null; }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          setCartCount(cart.item_count);
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          setTimeout(restore, 1800);
        })
        .catch(function (err) {
          restore();
          if (msg) msg.textContent = err && err.message && err.message.length < 140 ? err.message : 'Could not add to cart. Please try again.';
        });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(false, qs('[data-sg-primary]', box)); });
    addBtns.forEach(function (b) { if (b.type === 'button') b.addEventListener('click', function () { add(false, b); }); });
    if (buyBtn) buyBtn.addEventListener('click', function () { add(true, buyBtn); });

    var bar = qs('[data-sg-sticky]'), prim = qs('[data-sg-primary]', box);
    if (bar && prim && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var gone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', gone);
        bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
      }).observe(prim);
    }
    var cur = qs('[data-sg-var].is-on', box); if (cur) select(cur, false);
  }

  function init(scope) {
    initReveal(scope); initTilt(scope); initCompare(scope); initScenes(scope);
    qsa('[data-sg-buy]', scope).forEach(initBuy);
  }
  function boot() { init(document); initScroll(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();